import React from "react";
import { SquareChevronRight } from "lucide-react";
import { problems } from "../mock";
import QuoteCard from "./QuoteForm";
import SkyePromo from "./SkyePromo";

const ProblemsQuote = () => {
  return (
    <section id="quote" className="bg-white pt-3 pb-10 px-4" data-testid="quote-section">
      <div className="max-w-[1140px] mx-auto grid lg:grid-cols-2 gap-6 items-start">
        {/* Left: stove suffering */}
        <div className="fade-up">
          <div className="banner-shape text-center py-5 px-4" style={{ backgroundColor: "#343434", "--shape-fill": "#fff" }}>
            <h3 className="text-fire font-normal text-[22px] md:text-[28px]">
              Is Your <span className="text-white font-bold">Stove Suffering</span> From
            </h3>
          </div>
          <ul className="mt-6 space-y-3 flex flex-col items-center" data-testid="problems-list">
            {problems.items.map((it) => (
              <li key={it} className="flex items-center gap-3 text-charcoal font-medium text-[21px] md:text-[25px]">
                <SquareChevronRight className="text-fire flex-shrink-0" size={21} />
                {it}
              </li>
            ))}
          </ul>
          <p className="text-fire font-medium text-[19px] text-center mt-6 leading-relaxed px-2">
            Here at Stove Scotland we <span className="text-charcoal">GUARANTEE</span> that we can
            <span className="text-charcoal"> solve this problem</span> or
            <span className="text-charcoal"> your money back</span>, Please contact us for a free no obligation quote.
          </p>
          <SkyePromo />
        </div>

        {/* Right: quote form */}
        <div className="fade-up">
          <QuoteCard />
        </div>
      </div>
    </section>
  );
};

export default ProblemsQuote;
